import React from "react";
import { getTranslations, getNumberSuffix } from "../../../../Common/utils";
import useCloudinaryData from "../../../../Common/hooks/useCloudinaryData";
import { useSelector } from "react-redux";

const Prizes = ({ data, leagueName }) => {
  const { cloudinaryBase, envVersion, currentSeasonYear } = useCloudinaryData();
  const translationState = useSelector((state) => state.translation);

  if (!data) {
    return <div>Loading...</div>;
  }

  const { description, cta, prizeList } = data;

  // Function to process image URLs with Cloudinary data
  const processImageUrl = (imageUrl) => {
    if (!imageUrl || !cloudinaryBase || !envVersion || !currentSeasonYear) {
      return imageUrl;
    }

    return imageUrl
      ?.replace("<cloudinary_base_path>", cloudinaryBase)
      ?.replace("<env_version>", envVersion)
      ?.replace("<current_season_year>", currentSeasonYear)
      ?.replace("<mini_league_name>", leagueName);
  };

  // Prize modifiers based on position
  const getPrizeModifier = (positionNo) => {
    switch (positionNo) {
      case 1:
        return "gold";
      case 2:
        return "silver";
      case 3:
        return "bronze";
      default:
        return "gold";
    }
  };

  return (
    <>
      <div className="si-main__container">
        <div className="si-main__row">
          <div className="si-league__marketing-Prizes-wrap">
            <div className="si-league__marketing-Prizes-list">
              {prizeList &&
                prizeList.length > 0 &&
                prizeList.map((prize, index) => {
                  const processedImageUrl = processImageUrl(prize.image);
                  const modifier = getPrizeModifier(prize.positionNo);
                  const suffix = getNumberSuffix(prize.positionNo);

                  return (
                    <div
                      key={index}
                      className={`si-league__marketing-Prizes-box si-league__marketing-Prizes-box--${modifier}`}
                    >
                      <div className="si-league__marketing-Prizes-box-thumb">
                        <picture>
                          <img
                            src={processedImageUrl}
                            alt={getTranslations(
                              prize.positionText,
                              `${prize.positionNo}${suffix} Prize`
                            )}
                          />
                        </picture>
                      </div>
                      <div className="si-league__marketing-Prizes-box--content">
                        <div className="si-league__marketing-Prizes-box-pos">
                          <span>
                            {prize.positionNo}
                            {suffix} Prize
                          </span>
                        </div>
                        <div className="si-league__marketing-Prizes-box-title">
                          {getTranslations(prize.title, prize.title)}
                        </div>
                        <div className="si-league__marketing-Prizes-box-caption">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: getTranslations(
                                prize.desc,
                                prize.desc
                              )?.replace(
                                "{{LANGUAGE}}",
                                translationState?.language
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="si-league__marketing-Prizes-description">
              <p>
                {getTranslations(
                  description,
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor neque in odio cursus tempus. Aliquam sem magna, convallis vel vehicula ac, tempor luctus dolor. Aliquam et turpis ut mi tempor laoreet. Morbi at porta urna. Nunc pellentesque ligula eget mattis fringilla. In erat felis, vestibulum ac iaculis vel, finibus non eros. Praesent sit amet libero vel risus luctus mollis auctor in elit."
                )}
              </p>
            </div>
            {cta && getTranslations(cta.text) && (
              <div className="si-league__marketing-Prizes-link si-league__marketing-About-link">
                <a href={cta.url} target="_blank" rel="noopener noreferrer">
                  {getTranslations(cta.text)}
                  <i className="f1i-redirect"></i>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Prizes;
